import React from "react";
import { brl } from "../utils/formatters";
import HeroPanel from "./HeroPanel";
import CreditPanel from "./CreditPanel";
import BreakdownTable from "./BreakdownTable";
import ManualEntriesPanel from "./ManualEntriesPanel";

/**
 * Visão da semana: hero + (crédito aproveitado | movimento) + lançamentos
 * manuais + breakdown por tributo — mesma ordem do protótipo HTML.
 */
export default function WeekReport({ w, p, nome, range, lancamentos, obs, onAddLanc, onRemoveLanc, onObs }) {
  const mini = [
    ["Vendas faturadas", brl(w.vendas)],
    ["Devoluções de vendas", brl(w.dev)],
    ["Notas de saída", `${w.n_saidas} notas`],
    ["Notas de devolução", `${w.n_dev} ${w.n_dev === 1 ? "nota" : "notas"}`],
    ["Notas de entrada com crédito", `${w.n_ent} ${w.n_ent === 1 ? "nota" : "notas"}`],
    ["Guias de ICMS-ST e DIFAL", `${w.n_st} ${w.n_st === 1 ? "guia" : "guias"}`],
  ];

  return (
    <>
      <HeroPanel m={p} isMes={false} nomeSemana={nome} />

      <div className="grid-2">
        <CreditPanel
          rows={p.rows}
          sub="Parte do débito de cada tributo coberta por crédito nesta semana, já com os lançamentos manuais."
        />
        <div className="panel-card">
          <div className="panel-head">
            <div>
              <h5>Movimento da semana</h5>
              <p className="panel-sub">Notas emitidas de {range}.</p>
            </div>
          </div>
          <div className="mini-grid">
            {mini.map(([k, v]) => (
              <div key={k}>
                <span>{k}</span>
                <b>{v}</b>
              </div>
            ))}
          </div>
          <p className="footnote">
            Serviços, locação, ISS e os valores digitados nas fórmulas da
            planilha não têm data e entram só no mês consolidado.
          </p>
        </div>
      </div>

      <ManualEntriesPanel
        semanaNome={nome}
        lancamentos={lancamentos}
        efeitos={p.eff}
        obs={obs}
        onAdd={onAddLanc}
        onRemove={onRemoveLanc}
        onObs={onObs}
      />

      <BreakdownTable p={p} isMes={false} />
    </>
  );
}
